import Vue from "vue";
import {
  Container,
  Header,
  Main,
  Footer,
  Carousel,
  CarouselItem,
  Icon,
  Tabs,
  TabPane,
  Row,
  Col,
  Dialog,
  Button
} from "element-ui";
import App from "./App.vue";
import VueLazyload from "vue-lazyload";
import ErrorPage from "@/assets/images/error.png";
import LoadingPage from "@/assets/images/loading.svg";
import api from "@/utils/request/api/index";

Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Row);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(VueLazyload);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: ErrorPage,
  loading: LoadingPage,
  attempt: 1
});
Vue.prototype.$api = api;

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
